/** 证件名称list*/
export const SUPPLYTYPE_NAMELISTY = {
  url: 'certificate/manage/product/type/inspection',
  config: {
    method: 'post',
    host: 'SUPPLIER',
  },
};

/** table数组*/
export const SUPPLYTYPE_TABLELIST = {
  url: 'quote/manage/select/quote/list',
  config: {
    method: 'post',
    host: 'SUPPLIER',
  },
};

/** 各个状态数量*/
export const SUPPLYTYPE_ALLNUM = {
  url: 'certificate/manage/product/type/certCount',
  config: {
    method: 'post',
    host: 'SUPPLIER',
  },
};

/** 操作日志*/
export const SUPPLYTYPE_LOGTABLE = {
  url: 'quote/manage/select/quote/list',
  config: {
    method: 'post',
    host: 'SUPPLIER',
  },
};

/** 图片上传*/
export const SUPPLYTYPE_UPLOADIMAGE = {
  url: 'certificate/manage/upload/file',
  config: {
    method: 'post',
    host: 'SUPPLIER',
  },
};

/** 查看型检/批检所需证件*/
export const SUPPLYTYPE_LOOKTYPE = {
  url: 'certificate/manage/report/type/view',
  config: {
    method: 'post',
    host: 'SUPPLIER',
  },
};

/** 上传批件报告*/
export const SUPPLYTYPE_UPLOADPIREPORT = {
  url: 'certificate/manage/batch/report/upload',
  config: {
    method: 'post',
    host: 'SUPPLIER',
  },
};

/** 上传批件报告md5*/
export const SUPPLYTYPE_UPLOADPIREPORT_MD5 = {
  url: 'certificate/manage/batchReportUpload',
  config: {
    method: 'post',
    host: 'SUPPLIER',
  },
};

/** 上传型检报告*/
export const SUPPLYTYPE_UPLOADXINGREPORT = {
  url: 'certificate/manage/type/report/upload',
  config: {
    method: 'post',
    host: 'SUPPLIER',
  },
};
/** 上传型检报告md5*/
export const SUPPLYTYPE_UPLOADXINGREPORT_MD5 = {
  url: 'certificate/manage/typeReportUpload',
  config: {
    method: 'post',
    host: 'SUPPLIER',
  },
};

/** 查看型检/或编辑型检*/
export const SUPPLYTYPE_EDITUPLOADXINGREPORT = {
  url: 'certificate/manage/select/report/info',
  config: {
    method: 'post',
    host: 'SUPPLIER',
  },
};

/** 日志*/
export const SUPPLYTYPE_EDITUPLOADXING_LOG = {
  url: 'certificate/manage/product/type/typeLogInfo',
  config: {
    method: 'post',
    host: 'SUPPLIER',
  },
};

/** 日志*/
export const SUPPLYTYPE_EDITUPLOADXING_ALLCARD = {
  url: 'certificate/manage/cert/batch/all',
  config: {
    method: 'post',
    host: 'SUPPLIER',
  },
};

/** 删除日志 */
export const SUPPLYTYPE_EDITUPLOADXING_DELETE_BATCH_REPORT = {
  url: 'certificate/manage/batch/report/delete',
  config: {
    method: 'post',
    host: 'SUPPLIER',
  },
};

/** 日志*/
export const SUPPLYTYPE_EDITUPLOADXING_PRODUCTQUERY = {
  url: 'certificate/manage/cert/product/query',
  config: {
    method: 'get',
    host: 'SUPPLIER',
  },
};

/** 拒绝原因*/
export const API_POST_QUERY_NOUPLOADREASON = {
  url: 'certificate/manage/notNeed/Upload/Reason',
  config: {
    method: 'post',
    host: 'SUPPLIER',
  },
};

/**获取省市区数据*/
export const API_ADDRESS_CASCADER = {
  url: 'api/caisx/b2b/md/base/address/cascader',
  config: {
    method: 'get',
    host: 'CAISX_MDM',
  },
};

/**获取省市区数据*/
export const API_ADDRESS_CASCADERUPDATE_PLACE = {
  url: 'purchase/notice/add/or/update/product/place',
  config: {
    method: 'post',
    host: 'SUPPLIER',
  },
};

/**供应商是否有清理流程*/
export const API_GET_SUPPLIER_GET = {
  url: 'supplier/clear/get',
  config: {
    method: 'get',
    host: 'SUPPLIER',
  },
};

/**供应商清理流程审批*/
export const API_GET_SUPPLIER_AUDIT = {
  url: 'supplier/clear/audit',
  config: {
    method: 'post',
    host: 'SUPPLIER',
  },
};

/**供应商公告同意不同意*/
export const API_GET_SUPPLIER_NOTICE_AGREE = {
  url: 'index/notice/agree',
  config: {
    method: 'get',
    host: 'SUPPLIER',
  },
};

// 商品型检证件 - 列表
export const API_POST_TYPE_INSPECTION_CERTIGICATE_PEGE = {
  url: 'type/inspection/certificate/page',
  config: {
    method: 'post',
    host: 'SUPPLIER',
  },
};

// 商品型检证件 - 数量
export const API_POST_TYPE_INSPECTION_CERTIGICATE_COUNT = {
  url: 'type/inspection/certificate/count',
  config: {
    method: 'post',
    host: 'SUPPLIER',
  },
};

// 商品型检证件 - 获取需上传证件数据
export const API_POST_TYPE_INSPECTION_CERTIGICATE_UPLOAD_INFO = {
  url: 'type/inspection/certificate/upload/info',
  config: {
    method: 'get',
    host: 'SUPPLIER',
  },
};

// 商品型检证件 - 上传证件
export const API_POST_TYPE_INSPECTION_CERTIGICATE_UPLOAD = {
  url: 'type/inspection/certificate/upload',
  config: {
    method: 'post',
    host: 'SUPPLIER',
  },
};

// 商品型检证件 - 查看证件
export const API_POST_TYPE_INSPECTION_CERTIGICATE_VIEW = {
  url: 'type/inspection/certificate/view',
  config: {
    method: 'get',
    host: 'SUPPLIER',
  },
};

// 商品型检证件 - 日志列表
export const API_POST_TYPE_INSPECTION_CERTIGICATE_LOG_PAGE = {
  url: 'type/inspection/certificate/log/page',
  config: {
    method: 'post',
    host: 'SUPPLIER',
  },
};

// 商品型检证件 - 首页待办数量
export const API_POST_TYPE_INSPECTION_CERTIGICATE_NUM = {
  url: 'type/inspection/certificate/num',
  config: {
    method: 'post',
    host: 'SUPPLIER',
  },
};

// 商品型检证件 - 首页今日异常数量
export const API_POST_TYPE_INSPECTION_CERTIGICATE_TODAY_ERROR_NUM = {
  url: 'type/inspection/certificate/today/error/num',
  config: {
    method: 'post',
    host: 'SUPPLIER',
  },
};

// 供应商证件 - 列表
export const API_POST_CERTIFICATE_PAGE = {
  url: 'supplier/certificate/page',
  config: {
    method: 'post',
    host: 'SUPPLIER',
  },
};

// 计划委外看板
export const API_POST_OUTSOURCE_BOARD = {
  url: 'require/plan/outsource/board',
  config: {
    method: 'post',
    host: 'SUPPLIER',
  },
};

// 供应商证件 - 新建
export const API_POST_CERTIFICATE_ADD = {
  url: 'supplier/certificate/add',
  config: {
    method: 'post',
    host: 'SUPPLIER',
  },
};

// 供应商证件 - 编辑
export const API_POST_CERTIFICATE_UPDATE = {
  url: 'supplier/certificate/update',
  config: {
    method: 'post',
    host: 'SUPPLIER',
  },
};

// 供应商证件 - 查看详情
export const API_POST_CERTIFICATE_DETAIL = {
  url: 'supplier/certificate/details',
  config: {
    method: 'get',
    host: 'SUPPLIER',
  },
};

// 供应商证件 - 证件名称列表
export const API_POST_CERTIFICATE_BASELIST = {
  url: 'supplier/certificate/baseList',
  config: {
    method: 'POST',
    host: 'SUPPLIER',
  },
};

// 供应商证件 - 日志列表
export const API_POST_CERTIFICATE_LOG_PAGE = {
  url: 'supplier/certificate/log/page',
  config: {
    method: 'POST',
    host: 'SUPPLIER',
  },
};

// 供应商证件 - 根据供应商获取税号
export const API_POST_CERTIFICATE_TAXCODE = {
  url: 'supplier/certificate/taxCode',
  config: {
    method: 'GET',
    host: 'SUPPLIER',
  },
};

// 供应商证件 - 根据供应商获取税号
export const API_POST_BBC_ORDER_HOMESTOCKWARN = {
  url: 'bbc/order/homeStockWarn',
  config: {
    method: 'POST',
    host: 'SUPPLIER',
  },
};

// 供应商证件 - 首页待办数量
export const API_POST_CERTIFICATE_COUNT = {
  url: 'supplier/certificate/count',
  config: {
    method: 'GET',
    host: 'SUPPLIER',
  },
};

// 供应商证件 - 查询供应商证件列表-新
export const API_POST_NEW_CERTIFICATE_PAGE = {
  url: 'supplier/newCertificate/newPage',
  config: {
    method: 'post',
    host: 'SUPPLIER',
  },
};

// 供应商证件 - 查询变更申请分页-新
export const API_POST_NEW_CERTIFICATE_PAGE_TWO = {
  url: 'supplier/newCertificate/findSupplierFileApplyPage',
  config: {
    method: 'post',
    host: 'SUPPLIER',
  },
};

// 供应商证件 - 首页待办数量
export const API_POST_CERTIFICATE_COUNT_NEW = {
  url: 'supplier/newCertificate/newCount',
  config: {
    method: 'GET',
    host: 'SUPPLIER',
  },
};

// 供应商证件 - 查看详情
export const API_POST_CERTIFICATE_DETAIL_NEW = {
  url: 'supplier/newCertificate/newDetails',
  config: {
    method: 'post',
    host: 'SUPPLIER',
  },
};

// 供应商证件 -供应商证件码值
export const API_POST_GETSUPPLIERFILE_DETAIL_NEW = {
  url: 'supplier/newCertificate/getSupplierFileBaseConfig',
  config: {
    method: 'GET',
    host: 'SUPPLIER',
  },
};

// 供应商证件 - 新建
export const API_POST_CERTIFICATE_NEWADD = {
  url: 'supplier/newCertificate/newAddUpdate',
  config: {
    method: 'post',
    host: 'SUPPLIER',
  },
};

// 生产厂家证件 - 新建
export const API_POST_MANUFACTURER_CERT_ADD = {
  url: 'supplier/manufacturer/certificate/add',
  config: {
    method: 'post',
    host: 'SUPPLIER',
  },
};

// 生产厂家证件 - 编辑
export const API_POST_MANUFACTURER_CERT_UPDATE = {
  url: 'supplier/manufacturer/certificate/update',
  config: {
    method: 'post',
    host: 'SUPPLIER',
  },
};

// 生产厂家证件 - 查看详情
export const API_GET_MANUFACTURER_CERT_DETAIL = {
  url: 'supplier/manufacturer/certificate/details',
  config: {
    method: 'get',
    host: 'SUPPLIER',
  },
};

// 商品批检证件- 查询列表
export const API_POST_PRODUCT_CERTIFICATE_BATCHCHECK_LIST = {
  url: 'product/cert/batchCheck/productCertCheckList',
  config: {
    method: 'post',
    host: 'SUPPLIER',
  },
};

// 供应商证件 -供应商证件码值
export const API_POST_PRODUCT_CERTIFICATE_BATCHCHECK_ITEM = {
  url: 'product/cert/batchCheck/list/item',
  config: {
    method: 'post',
    host: 'SUPPLIER',
  },
};

// 型检证件枚举值
export const API_POST_BASE_CERT_BATCH_LIST = {
  url: 'product/cert/batchCheck/getCertEnum',
  config: {
    method: 'GET',
    host: 'SUPPLIER',
  },
};

// 型检-批量上传
export const API_POST_PRODUCT_CERT_BATCHCHECK_UPLOAD_BATCH = {
  url: 'product/cert/batchCheck/uploadBatch',
  config: {
    method: 'post',
    host: 'SUPPLIER',
  },
};

// 型检-批量上传
export const API_POST_PRODUCT_CERT_BATCHCHECK_CERTDETAIL = {
  url: 'product/cert/batchCheck/certDetail',
  config: {
    method: 'post',
    host: 'SUPPLIER',
  },
};

// 型检-批量上传-删除
export const API_POST_PRODUCT_CERT_BATCHCHECK_DELBATCH = {
  url: 'product/cert/batchCheck/delBatch',
  config: {
    method: 'post',
    host: 'SUPPLIER',
  },
};

// 商品型检证件 - 上传证件
export const API_POST_TYPE_INSPECTION_RELATION_PRODUCT_CERT_INFO = {
  url: 'type/inspection/certificate/relationProduct/cert/info',
  config: {
    method: 'get',
    host: 'SUPPLIER',
  },
};
// 商品型检证件 - 日志列表
export const API_POST_SUPPLIER_DATA_LOG_PAGE = {
  url: 'supplier/data/log/page',
  config: {
    method: 'post',
    host: 'SUPPLIER',
  },
};
